import { CookieManager } from "../services/CookieManager/CookieManager";
import { DEVICE_COOKIE, MARKETING_COOKIE, SESSION_COOKIE } from "@nf/constants";
import { ITokenModel } from "../models";

const expireInNextWeek: Date = new Date(
  new Date().setDate(new Date().getDate() + 7)
);

export const CookieHelper = {
  getSession: (): Promise<ITokenModel | undefined> => {
    try {
      const session = CookieManager.getCookie(SESSION_COOKIE) as string;
      const sessionObject = JSON.parse(session);
      return Promise.resolve(sessionObject);
    } catch (e) {
      return Promise.resolve(undefined);
    }
  },

  setSession: (value?: ITokenModel): Promise<void> => {
    CookieManager.add(SESSION_COOKIE, value, expireInNextWeek);
    return Promise.resolve();
  },

  deleteSession: () => {
    return Promise.resolve();
  },

  getDevice: () => {
    try {
      const device = CookieManager.getCookie(DEVICE_COOKIE) as string;
      const parsedDevice = JSON.parse(device);
      return Promise.resolve(parsedDevice);
    } catch {
      return Promise.resolve(undefined);
    }
  },

  setDevice: (value: string) => {
    const expiresInYear: Date = new Date(
      new Date().setFullYear(new Date().getFullYear() + 1)
    );
    CookieManager.add(DEVICE_COOKIE, value, expiresInYear);
    return Promise.resolve();
  },

  setMarketing: (value?: boolean) => {
    CookieManager.add(MARKETING_COOKIE, !!value, expireInNextWeek);
    return Promise.resolve();
  },
};
